import { connect } from 'react-redux';
import _ from 'lodash';

import { setPopUp } from 'client/actions';
import Email from './Email';

export default connect(
	state => {
		const selectedIds = _.get(state, 'items.selected', []);
		const items = _.get(state, 'items.list', []);
		const selected = _.map(
			_.filter(items, item => !selectedIds.includes(item._id)),
			s => ({
				title: s.title,
				text: s.subtitle,
			})
		);

		return {
			selected,
		};
	},
	dispatch => ({
		onCloseClick: () => dispatch(setPopUp(null)),
	})
)(Email);
